import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import moment from 'moment';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { enpointCervinoWeb } from '../../configuration/enpointsCervino';
import { LogFilterModel } from '../../models/audit/log-filter.model';
import { ColumnResponseModel } from '../../models/responses/column-response.model';
import { PagedResponseModel } from '../../models/responses/paged-response.model';
import { LogTableModel } from '../../models/tables/audit/log-table.model';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  private readonly _httpClient = inject(HttpClient);

  getAllWithPagination(
    page: number,
    limit: number,
    columnSort: string | null,
    ascendant: boolean,
    logFilterModel: LogFilterModel
  ): Observable<PagedResponseModel<LogTableModel>> {
    let params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('filter.TimeStamp', this.formatDate(logFilterModel.timeStamp));

    if (logFilterModel.timeStampFinal) {
      params = params.set('filter.TimeStampFinal', this.formatDate(logFilterModel.timeStampFinal));
    }

    if (logFilterModel.message) params = params.set('filter.Message', logFilterModel.message);
    if (logFilterModel.userName) params = params.set('filter.UserName', logFilterModel.userName);
    if (logFilterModel.service) params = params.set('filter.Service', logFilterModel.service);
    if (logFilterModel.method) params = params.set('filter.Method', logFilterModel.method);

    return this._httpClient.post<PagedResponseModel<LogTableModel>>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.log.GetAllWithPaginationAsync}`,
      {},
      { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.log.GetColumnsForGeneralConsultation}`
    );
  }

  private formatDate(date: Date | null): string {
    if (!date) return '';
    return moment(date).format('YYYY-MM-DD');
  }
}
